
          import p from "/home/nathan/goalert/web/src/app/public/logos/black/goalert-alt-logo.png"
          const prefixPath = pathPrefix + "/static/" + p
          export default prefixPath
        